import { useCallback } from 'react';
import type { GridApi } from 'ag-grid-community';

type OnFirstDataRendered = ({ api }: { api: GridApi }) => void

export const applyFiltersInitialValue = (
  initialFilters?: Record<string, any>
) => (
  { api: gridApi }: { api: GridApi }
) => {
  gridApi.setFilterModel(
    Object.entries(initialFilters || {} as Record<string, any>)
      .filter(([, values]) => values)
      .map(([fieldName, values]): [string, any] => [fieldName, Array.isArray(values) ? values : [values]])
      .reduce((accu, [fieldName, values]) => ({
        ...accu,
        [fieldName]: {
          filterType: 'set',
          values,
        },
      }), {})
  );
};

export const useApplyFiltersInitialValue = (initialFilters?: Record<string, any>): OnFirstDataRendered => {
  const onFirstDataRendered = useCallback<OnFirstDataRendered>(
    ({ api }) => applyFiltersInitialValue(initialFilters)({ api }),
    [initialFilters]
  );

  return onFirstDataRendered;
};
